<template>
  <section>
    <a
        class="tab_button tab_button_refresh title_tooltip"
        :data-title="'Obnovit' | translate"
        @click.stop.prevent="emitDevicesRefresh"
        v-translate>
    </a>
    <div class="status">
      <h2 v-translate>Párovací kódy</h2>
      <a v-if="isEditable"
                    :title="'Přidat párovací kód' | translate"
          :class="['add', 'add_expand', { open: newPairingCodeOpen }, { btn_inactive: !isAllowedToAddDeviceOrPairingCode}]"
          @click.prevent="toggleNewPairingCodes()"
          v-translate>Přidat párovací kód
      </a>
    </div>
    <div :class="['filter', 'expand_content', { open: newPairingCodeOpen }]">
      <div class="field_left">
        <select-box
            id="deviceselect"
            :options="pairingCodeDeviceOptions"
            v-model="pairingCodeDeviceId"
            ref="deviceselectref"
        >
          <translate class="translate">Zařízení</translate>
        </select-box>
      </div>
      <div class="field_right">
        <date-picker
            id="active-to-add"
            attrKey="expiration_date"
            date-format="d. m. yy"
            v-model="newPairingCode.expiration_date"
            @update-date="updateNewPairingCodeDate"
        >
          <translate class="translate">Platnost pro zadání kódu</translate>
        </date-picker>
      </div>
      <div class="field_left">
        <text-input
            id="device-name-add-2"
            v-model="newPairingCode.name"
            :required="true"
            ref="newpairingcodename"
            :disabled="pairingCodeDeviceId !== null"
        >
          <translate class="translate">Název zařízení</translate>
        </text-input>
      </div>
      <div class="field_left"><div class="field"></div> </div>
      <div class="field_right">
        <div class="field">
          <input
              type="submit"
              class="btn"
              :value="'Uložit' | translate"
              @click.prevent.stop="emitAddNewPairingCode"
          />
        </div>
      </div>
    </div>
    <div class="table_overflow">
      <table class="vypis vypis_detail parovaci_kody">
      <not-sorting-table-header
          :titles="pairingCodeTableTitles"
      ></not-sorting-table-header>
      <tbody>
      <pairing-code-row
          v-for="pairingCode in pairingCodes"
          :pairingCode="pairingCode"
          :key="pairingCode.id"
          @delete-pairing-code="emitPairingCodeDelete">
      </pairing-code-row>
      </tbody>
    </table>
    </div>
    <div class="status">
      <h2 v-translate>Spárovaná zařízení</h2>
      <a v-if="isEditable"
                    :title="'Přidat zařízení' | translate"
          :class="['add', 'add_expand', { open: newDeviceOpen }, { btn_inactive: !isAllowedToAddDeviceOrPairingCode}]"
          @click.prevent="toggleNewDevices()"
          v-translate>Přidat zařízení
      </a>
    </div>
    <div :class="['filter', 'expand_content', { open: newDeviceOpen }]">
      <div class="field_left">
        <text-input
            id="device-name-add-1"
            v-model="newDevice.name"
            :required="true"
            ref="newdevicenameref"
        >
          <translate class="translate">Název zařízení</translate>
        </text-input>
      </div>
      <div class="field_right">
        <text-input
            id="mac-address-add"
            v-model="newDevice.mac_address"
            :required="true"
            ref="newdevicemacaddressref"
        >
          <translate class="translate">MAC adresa</translate>
        </text-input>
      </div>
      <div class="field_left"><div class="field"></div> </div>
      <div class="field_right">
        <div class="field">
        <input
            type="submit"
            class="btn"
            :value="'Uložit' | translate"
            @click.prevent.stop="emitAddNewDevice"
        />
        </div>
      </div>
    </div>
    <div class="table_overflow">
      <table class="vypis">
      <not-sorting-table-header
          :titles="pairedDeviceTableTitles"
          :drag-drop="true"
          :checkbox="true"
      ></not-sorting-table-header>
      <paired-device-row
          v-for="device in devices"
          :device="device"
          :key="device.id"
          :device-profiles="deviceProfiles"
          :selectedEntities="selectedEntities"
          :isEditable="isEditable"
          :deviceLogViewerUrl="deviceLogViewerUrl"
          :showDeviceToken="showDeviceToken"
          @input="select"
          @update-device="emitUpdateDevice"
          @delete-device="emitDeviceDelete"
          :ref="'paired-device-row-ref-' + device.id"
      ></paired-device-row>
    </table>
    </div>
    <local-list-action-line
        :entities="devices"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        @select-all="toggleSelectAll"
        @run-multiple-action="executeMultipleAction"
    ></local-list-action-line>
  </section>
</template>

<script>
import PairedDeviceRow from "@/components/views/subscribers/devices/PairedDeviceRow"
import PairingCodeRow from "@/components/views/subscribers/devices/PairingCodeRow"
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import requiredFields from "@/components/mixins/required-fields"
import localTable from "@/components/mixins/local-table"

export default {
  name: "Devices",
  components: {
    NotSortingTableHeader,
    PairedDeviceRow,
    PairingCodeRow
  },
  mixins: [requiredFields, localTable],
  data() {
    return {
      requiredDeviceRefs: [
        'newdevicenameref',
        'newdevicemacaddressref',
      ],
      requiredPairingCodeRefs: [
        'newpairingcodename',
      ],
      pairingCodeDeviceId: null,
    }
  },
  props: {
    idSubscriber: Number,
    deviceProfiles: Array,
    devices: [Object, Array],
    newDevice: Object,
    newDeviceOpen: Boolean,
    pairingCodes: [Object, Array],
    newPairingCode: Object,
    newPairingCodeOpen: Boolean,
    deviceService: Object,
    deviceLogViewerUrl: String,
    isAllowedToAddDeviceOrPairingCode: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [Array, Object],
      default: function () {
        return []
      },
    },
    isEditable: Boolean,
  },
  mounted(SubscriberService){
    this.subscriberService = SubscriberService;
  },
  computed: {
    pairingCodeDeviceOptions(){
      let result = Object.values(this.devices).map(obj => ({
        id: obj.id,
        text: obj.name
      }));
      result.unshift({'id': null, 'text':this.$gettext('Bez zařízení')});
      return result;
    },
    showDeviceToken(){
      return this.$_loggedUser_action_allowed('subscribers', 'read', ['OWN_AND_GLOBAL', 'ALL']);
    },
    pairedDeviceTableTitles() {
      const titles = [
        this.$gettext('Název zařízení'),
        this.$gettext('Přednastavený'),
        this.$gettext('MAC adresa'),
        this.$gettext('Profil'),
        this.$gettext('Typ'),
        this.$gettext('Model'),
        this.$gettext('Firmware'),
        this.$gettext('Aplikace')
      ]

      if (this.isEditable && this.showDeviceToken) {
        titles.push(this.$gettext('Token'))
      }

      titles.push(this.$gettext('Poslední start zařízení'));
      titles.push(this.$gettext('Vytvořeno'))

      return titles
    },
    pairingCodeTableTitles() {
      return [
        this.$gettext('Název zařízení'),
        this.$gettext('Párovací kód'),
        this.$gettext('Platné do'),
        this.$gettext('Vytvořeno')
      ]
    },
    entities(){
      return Object.values(this.devices);
    },
    csvHeaders(){
      let headers = {
        'name': {name: this.$gettext('Název zařízení')},
        'pre_provisioned': {name: this.$gettext('Přednastavený'), callback: (entity) => {return entity.pre_provisioned ? this.$gettext("Ano") : this.$gettext("Ne")}},
        'mac_address': {name: this.$gettext('MAC adresa')},
        'profile': {name: this.$gettext('Profil')},
        'type': {name: this.$gettext('Typ')},
        'model': {name: this.$gettext('Model')},
        'firmware': {name: this.$gettext('Firmware')},
        'application': {name: this.$gettext('Aplikace')},
      }
      if (this.isEditable) {
        headers.token = {name: this.$gettext('Token')};
      }
      headers.last_start = {name: this.$gettext('Poslední start zařízení'), callback: (entity) => {return entity.last_start ? this.$_datetime_format(entity.last_start) : ''}};
      headers.date_created = {name: this.$gettext('Vytvořeno')};

      return headers;
    },
    multipleActionOptions() {
      let options = [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ];
      if (this.$_loggedUser_action_allowed('devices', 'update')) {
        options.push({value: 'softrestart', text: this.$gettext('Soft restart')});
        options.push({value: 'hardrestart', text: this.$gettext('Hard restart')});
        options.push({value: 'forcefullreload', text: this.$gettext('Force full reload')});
      }
      if (this.$_loggedUser_action_allowed('devices', 'delete')) {
        options.push({value: 'delete', text: this.$gettext('Smazat')});
      }

      return options;
    }
  },
  methods: {
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'softrestart':
          this.deviceService.restartDevices(actionIds, "soft").then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K soft restartování označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        case 'hardrestart':
          this.deviceService.restartDevices(actionIds, "hard").then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K hard restartování označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        case 'forcefullreload':
          this.deviceService.forceFullReloadDevices(actionIds).then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K přenačtení označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    },
    closeRows() {
      this._.forEach(this.devices, (device) => {
        this.$refs['paired-device-row-ref-' + device.id][0].hideMoreInfo()
      })
    },
    validateRequiredFields(error) {
      if (this.newDeviceOpen) {
        if (!this.newDevice.name) {
          this.$refs['newdevicenameref'].setForcedInvalid(true, this.$gettext('Zadejte název'))
        } else {
          this.resetNewDeviceName()
        }

        if (!this.newDevice.mac_address) {
          this.$refs['newdevicemacaddressref'].setForcedInvalid(true, this.$gettext('Přednastavené zařízení musí mít vyplněnou MAC adresu.'))
        } else if (this.newDevice.mac_address.length < 17) {
          this.$refs['newdevicemacaddressref'].setForcedInvalid(true, this.$gettext('MAC adresa musí obsahovat 17 znaků ve správném formátu'))
        } else {
          this.resetNewDeviceMacAddress()
        }
      }
      if (this.newPairingCodeOpen) {
        if (!this.newPairingCode.name) {
          this.$refs['newpairingcodename'].setForcedInvalid(true, this.$gettext('Zadejte název'))
        } else {
          this.resetNewPairingCode()
        }
      }
    },
    resetNewDevice() {
      this.resetNewDeviceName()
      this.resetNewDeviceMacAddress()
    },
    resetNewDeviceName() {
      this.$refs['newdevicenameref'].setForcedInvalid()
      this.$refs['newdevicenameref'].setTouched(false)
    },
    resetNewDeviceMacAddress() {
      this.$refs['newdevicemacaddressref'].setForcedInvalid()
      this.$refs['newdevicemacaddressref'].setTouched(false)
    },
    resetNewPairingCode() {
      this.$refs['newpairingcodename'].setForcedInvalid()
      this.$refs['newpairingcodename'].setTouched(false)
    },
    toggleNewDevices() {
      const value = this.isAllowedToAddDeviceOrPairingCode ? !this.newDeviceOpen : false
      this.$emit('new-device-open', value)
    },
    toggleNewPairingCodes() {
      const value = this.isAllowedToAddDeviceOrPairingCode ? !this.newPairingCodeOpen : false
      this.pairingCodeDeviceId = null;
      this.$emit('new-pairing-code-open', value)
    },
    updateNewPairingCodeDate(dateInfo) {
      this.newPairingCode[dateInfo.attrKey] = dateInfo.date
    },
    deleteEntity(id, showPopup = true) {
      if (showPopup) {
        if (this._.includes(id, ',')) {
          this.showPopup(id, 'delete-multi', 'delete-device-multi')
        } else {
          this.showPopup(id, 'delete', 'delete-device')
        }
      }
    },
    emitDeviceDelete(id) {
      this.$emit('delete-device', id)
    },
    emitPairingCodeDelete(id) {
      this.$emit('delete-pairing-code', id)
    },
    emitDevicesRefresh() {
      this.$emit('devices-refresh')
    },
    emitAddNewDevice() {
      this.$emit('add-new-device')
    },
    emitUpdateDevice(data) {
      this.$emit('update-device', data)
    },
    emitAddNewPairingCode() {
      this.$emit('add-new-pairing-code')
    }
  },
  watch: {
    pairingCodeDeviceId(){
      if(this.pairingCodeDeviceId === null){
        this.newPairingCode.name = '';
      }else{
        this.newPairingCode.name = this.devices[this.pairingCodeDeviceId].name;
      }
      this.newPairingCode.id_device = this.pairingCodeDeviceId ? Number(this.pairingCodeDeviceId) : null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/devices/Devices.vue